// @flow
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import Experiment, {Variant} from '@homeaway/react-experiment';
import {SVGIcon} from '@homeaway/react-svg';
import {VIEWED_COLOR__24} from '@homeaway/svg-defs';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {VRBO_SERP_SEE_MORE_PROMPT} from '../../../abacus/experiments';
import SimilarListingsCarousel from '../../SimilarListingsCarousel/SimilarListingsCarousel';
import {useFetchSimilarListings} from '../../../hooks/useFetchSimilarListings/useFetchSimilarListings';

const Thanks = ({isMobile, locale, searchParams, listingId}) => {
    const [displayFallbackMessage, setDisplayFallbackMessage] = useState(true);

    const {similarListings, similarListingsLoading} = useFetchSimilarListings(
        searchParams,
        listingId
    );

    useEffect(() => {
        if (!similarListingsLoading && isEmpty(similarListings)) {
            setTimeout(() => {
                setDisplayFallbackMessage(false);
            }, 3000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [similarListingsLoading]);

    if (!isEmpty(similarListings) && !similarListingsLoading) {
        return (
            <div className="Thanks Thanks--withCarousel">
                <SimilarListingsCarousel
                    isMobile={isMobile}
                    locale={locale}
                    similarListings={similarListings}
                />
            </div>
        );
    }

    const className = classNames('Thanks', {
        'Thanks--loading': similarListingsLoading
    });

    return (
        displayFallbackMessage && (
            <div className={className}>
                <Experiment name={VRBO_SERP_SEE_MORE_PROMPT} deferLogging>
                    <Variant variant={1}>
                        <SVGIcon
                            markup={VIEWED_COLOR__24}
                            className={'Thanks__icon'}
                        />
                    </Variant>
                </Experiment>
                <p className="Thanks__text">
                    {similarListingsLoading ? (
                        <LoadingOverlay />
                    ) : (
                        <FormattedMessage
                            id="thanks"
                            description="Thanks"
                            defaultMessage="Thanks!"
                        />
                    )}
                </p>
            </div>
        )
    );
};

const mapStateToProps = (state) => {
    const {system, searchParams} = state;
    const {isMobile, locale} = system;

    return {
        isMobile,
        locale,
        searchParams
    };
};

export default connect(mapStateToProps)(Thanks);
